var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"Table"},[_c('thead',{staticClass:"Table__head"},[(_vm.head)?_c('tr',{staticClass:"TableHead__row"},_vm._l((_vm.head),function(item){return _c('th',{staticClass:"TableHead__col"},[_vm._v(_vm._s(item))])}),0):_vm._e(),_vm._v(" "),_vm._t("thead")],2),_vm._v(" "),_c('tbody',{staticClass:"Table__body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }